import { render } from "./ContentsContainer.vue?vue&type=template&id=485dcccc&scoped=true"
import script from "./ContentsContainer.vue?vue&type=script&lang=js"
export * from "./ContentsContainer.vue?vue&type=script&lang=js"

import "./ContentsContainer.vue?vue&type=style&index=0&id=485dcccc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485dcccc"]])

export default __exports__